// extracted by mini-css-extract-plugin
export default {"inputNumber":"filter-number_inputNumber__qrSrG"};